define('modules/form_editor/models/custom_separator',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element");
  module.exports = BaseFormElement.extend({
    name: "custom:separator",
    onlyFieldAttrs: true,
    defaultValues: {
      elementId: "",
      height: "50",
      hrWidth: "50",
      hrHeight: "1",
      hrAlign: "none",
      showHr: false
    }
  });
});

